import React, { useState, useEffect } from 'react';

interface IzakayaWhatsAppButtonProps {
  lang: 'ja' | 'en';
}

export const IzakayaWhatsAppButton: React.FC<IzakayaWhatsAppButtonProps> = ({ lang }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleClick = () => {
    const message = lang === 'ja' 
      ? `こんにちは！東京居酒屋ナイトツアーに興味があります🍺

【ご希望日】　　年　　月　　日
【参加人数】　　名
【ご希望エリア】荏原町 / 中延 / 戸越 / 武蔵小山（どれでも可）

初めての参加です。詳細・空き状況を教えていただけますか？`
      : `Hi! I'm interested in booking the Tokyo Local Izakaya Night Tour 🍺

[Preferred Date]: 
[Number of Guests]: 
[Preferred Area]: Ebara-cho / Nakanobu / Togoshi / Musashi-Koyama (any is fine)

It's my first time. Could you share availability and details? Thank you!`;
    const whatsappUrl = `https://wa.me/819092895522?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
  };

  const buttonText = lang === 'ja' ? '予約する' : 'Book Now';

  return (
    <button
      onClick={handleClick}
      className={`fixed bottom-6 left-1/2 -translate-x-1/2 z-50 flex items-center gap-3 px-8 py-4 bg-green-500 hover:bg-green-600 text-white font-bold rounded-full shadow-2xl transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer ${
        isVisible ? 'translate-y-0 opacity-100' : 'translate-y-20 opacity-0 pointer-events-none'
      }`}
      style={{ transition: 'all 0.3s ease-in-out' }}
    >
      <i className="ri-whatsapp-line text-2xl"></i>
      <span className="text-lg">{buttonText}</span>
    </button>
  );
};